define([
        'underscore',
        'edge/quoteandbind/common/models/Submission',
        'edge/quoteandbind/mfp/models/Driver',
        'edge/quoteandbind/common/models/Person',
        'edge/quoteandbind/mfp/models/Vehicle',
        'edge/quoteandbind/mfp/constants/MFPVehicleConstants',
    ], (_, Submission, Driver, Person, Vehicle, MFP_VEHICLE_CONSTANTS) => {

        let nextId;

        const MFPSubmissionDraftDataExtension = function (submission) {
            nextId = submission.nextId;

            const data = submission.draftData.lobs.mFPLine;

            if (data && _.isObject(data)) {
                this.drivers = _.map(data.drivers, (d) => {
                    const driver = new Driver(d);
                    driver.person = submission.findPerson(submission, d.person);
                    return driver;
                }, this);

                this.vehicles = _.map(data.vehicles, v => new Vehicle(v), this);

                this.preQualQuestionSets = data.preQualQuestionSets;
                this.licensePlateNumber = data.licensePlateNumber;
                this.annualMileage = data.annualMileage;
                this.paidTransportOfGoodsUse = data.paidTransportOfGoodsUse;

            } else {
                this.drivers = [];
                this.vehicles = [];
                this.preQualQuestionSets = [];
            }

        };

        MFPSubmissionDraftDataExtension.prototype.initMinimumRiskDataQuestionSets = function () {
            //NOTE1: these questionSets are MFPline specific. they must be initilized and answered by customer OR defaulted
            //even before Draft Quote is created

            //opposite value if undefined, which is considered as value exists!   (asnwer value is false)
            this.preQualQuestionSets.push({
                code: 'MFPQuestionsToPolicyHolder',
                answers: {HadVehicleHolderAndDriversClaims: null}
            });
            this.preQualQuestionSets.push({code: 'BSLgeneralUWQuestions', answers: {}});
        };

        MFPSubmissionDraftDataExtension.prototype.createDriver = function (person) {
            const driver = new Driver({person: person});

            driver.tempID = nextId();

            this.drivers.push(driver);
            return driver;
        };

        MFPSubmissionDraftDataExtension.prototype.removeAllDrivers = function () {
            this.drivers = [];
        };

        MFPSubmissionDraftDataExtension.prototype.removeDriver = function (driver) {
            const idx = _.indexOf(this.drivers, driver);
            if (idx >= 0) {
                this.drivers.splice(idx, 1);
            }
        };

        MFPSubmissionDraftDataExtension.prototype.createVehicle = function (mainVehicle) {
            const v = new Vehicle({tempID: nextId()});

            // Main vehicle has to have number 1, additional one has to have number 2
            if (mainVehicle) {
                v.vehicleNumber = MFP_VEHICLE_CONSTANTS.MAIN_VEHICLE_NUMBER;
            } else {
                v.vehicleNumber = MFP_VEHICLE_CONSTANTS.ADDITIONAL_VEHICLE_NUMBER;
            }

            this.vehicles.push(v);
            return v;
        };

        MFPSubmissionDraftDataExtension.prototype.removeVehicle = function (vehicle) {
            const idx = _.indexOf(this.vehicles, vehicle);
            if (idx >= 0) {
                this.vehicles.splice(idx, 1);
            }
        };

        MFPSubmissionDraftDataExtension.prototype.getDriverForPerson = function (person) {
            const driver = _.findWhere(
                this.drivers, {person}
            );

            if (!driver) {
                return undefined;
            }

            return driver;
        };

        /**
         * NOTE:
         * If there is no driver - create one,
         * If there is a driver and it is the same person as given @person - update only person
         * If there is a driver, but it is different person - remove previuos driver and add new one
         * @param person
         */
        MFPSubmissionDraftDataExtension.prototype.createOrUpdateMainDriver = function (person) {
            if (!this.hasDrivers()) {
                this.createDriver(person);
            } else if (this.drivers[0].person.publicID === person.publicID) {
                this.drivers[0].person = person;
            } else {
                this.removeDriver(this.drivers[0]);
                this.createDriver(person);
            }
        };

        MFPSubmissionDraftDataExtension.prototype.hasVehicles = function () {
            return Boolean(this.vehicles && this.vehicles.length > 0);
        };

        MFPSubmissionDraftDataExtension.prototype.hasPreQualQuestionSets = function () {
            return Boolean(this.preQualQuestionSets && this.preQualQuestionSets.length > 0);
        };

        MFPSubmissionDraftDataExtension.prototype.hasDrivers = function () {
            return Boolean(this.drivers && this.drivers.length > 0);
        };

        MFPSubmissionDraftDataExtension.prototype.driverCitySet = function (submission) {
            let driverCitySet = true;
            if (this.hasDrivers()) {
                driverCitySet = submission.draftData.lobs.mFPLine.drivers[0].person.primaryAddress.city != null;
            }
            return driverCitySet;
        };


        MFPSubmissionDraftDataExtension.prototype.hasAdditionalVehicle = function () {
            return this.vehicles.length > 1;
        };

        /**
         * Returns the additional vehicle if it exists.
         * @returns {the additional vehicle, if it exists, undefined otherwise.}
         */
        MFPSubmissionDraftDataExtension.prototype.getAdditionalVehicle = function () {
            return this.hasAdditionalVehicle() ? this.vehicles[1] : undefined;
        };

        return MFPSubmissionDraftDataExtension;
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/models/MFPSubmissionDraftDataExtension.js